import $ from 'jquery';
import { appendFormError } from '../helper/updateFormErrors';

const PaymentDataHelper = function (UserControl) {
    var service = {};

    service.factory = function ($scope) {
        $scope.resetDebitFormErrors = function () {
            var formObj = document.getElementById('register-form-debit');

            if (!formObj) {
                return;
            }

            formObj.classList.remove('submit');
            $(formObj).find('.formerror').html('');
        };

        $scope.showDebitFormErrors = function () {
            var formObj = document.getElementById('register-form-debit');

            if (!formObj) {
                return;
            }

            formObj.classList.add('submit');
            $(formObj).find('.formerror').html('');
            var firstInvalid = null;
            $(formObj).find('input[data-validation]').each(function () {
                if (!this.validity.valid) {
                    if (!firstInvalid) {
                        firstInvalid = this;
                    }
                    appendFormError($(this));
                }
            });
            if (firstInvalid) {
                firstInvalid.focus();
            }
        };

        $scope.syncDebitFieldError = function (inputId) {
            var input = document.getElementById(inputId);

            if (!input) {
                return;
            }

            var form = input.form;

            var validationTargets = input.getAttribute('data-validation');

            if (!validationTargets) {
                return;
            }

            if (input.validity.valid) {
                validationTargets.split(',').forEach(function (targetId) {
                    var formError = document.getElementById(targetId);

                    if (formError) {
                        formError.innerHTML = '';
                    }
                });
                return;
            }

            if (!form || !form.classList.contains('submit')) {
                return;
            }

            appendFormError($(input));
        };

        $scope.checkPaymentForm = function () {
            var formID = 'register-form-debit';
            var formObj = document.getElementById(formID);
            var valid = $scope.checkIban() && formObj.checkValidity();
            $scope.paymentDataValid = valid;
            return valid;
        };

        $scope.checkIban = function () {
            let ibanValue = $scope.debit.iban;
            const ibanInput = document.getElementById('debit_iban');
            const isIbanValid = IBAN.isValid(ibanValue);

            if (!ibanValue || !isIbanValid) {
                if (typeof $scope.translations[ 'custom' ] === "undefined" || typeof $scope.translations[ 'custom' ][ 'please_enter_valid_iban' ] === "undefined") {
                    $scope.translations[ 'custom' ] = translations;
                }
                ibanInput.setCustomValidity($scope.translations[ 'custom' ][ 'please_enter_valid_iban' ]);
                $scope.syncDebitFieldError('debit_iban');
                return false;
            }

            ibanInput.setCustomValidity('');
            $scope.syncDebitFieldError('debit_iban');
            return true;
        };

        $scope.focusChangePaymentDataButton = function () {
            $scope.$evalAsync(function () {
                requestAnimationFrame(function () {
                    const btn = document.getElementById('change-payment-data-button');
                    if (btn) { btn.focus(); }
                });
            });
        };

        $scope.loadPaymentData = function (focusChangeButton) {
            $scope.debit.editable = true;
            if (UserControl.customer.id && UserControl.customer.status !== 3) {
                let postBoxDocument = $scope.projectName + '-' + UserControl.customer.id;

                postboxHelper.get('/postbox/CustomerPaymentData?document=' + postBoxDocument, function (response, request) {
                    if (!response.error) {
                        // Zahlungsdaten zum Customer wurden aus der Postbox geladen
                        // Initial sind die Textfelder nicht editierbar (editable)
                        // Bei Speichern der Daten muss das Postbox Dokument überschrieben werden statt ein neues anzulegen (overwrite)
                        $scope.debit.accountOwner = response.accountOwner;
                        $scope.debit.iban = response.iban;
                        $scope.debit.bic = response.bic;
                        $scope.debit.editable = false;
                        $scope.debit.overwrite = true;
                        $scope.debit.accept = true;
                    } else {
                        $scope.debit.iban = '';
                        $scope.debit.bic = '';
                        $scope.debit.editable = true;
                        $scope.debit.overwrite = false;
                        $scope.debit.accept = false;
                    }
                    $scope.checkCheckoutPossible();
                    if (focusChangeButton && !response.error) {
                        $scope.focusChangePaymentDataButton();
                    }
                });
            }
        };

        $scope.setEditable = function () {
            if (UserControl.customer.status !== 3) {
                $scope.debit.iban = '';
                $scope.debit.bic = '';
            }
            $scope.debit.editable = true;
            $scope.checkCheckoutPossible();
            setTimeout(function () {
                var firstInput = document.querySelector('#payment-data input:not([disabled])');
                if (firstInput) {
                    firstInput.focus();
                }
            }, 0);
        };

        $scope.updatePaymentData = function () {
            let valid = $scope.checkPaymentForm();
            if (!valid) {
                $scope.showDebitFormErrors();
            } else {

                if (UserControl.customer.status === 3 && !$scope.formStatus.registerForPaymentMode && !$scope.formStatus.loginForPaymentMode) {
                    $scope.debit.editable = false;
                    $scope.resetDebitFormErrors();
                    $scope.checkCheckoutPossible();
                    $scope.focusChangePaymentDataButton();
                    return;
                }

                let postBoxDocument = $scope.projectName + '-' + UserControl.customer.id;
                let encodedIban = '';
                if ($scope.debit.iban.length > 0) {
                    encodedIban = '***' + $scope.debit.iban.substr($scope.debit.iban.length - 4, 4);
                }

                let ibanCustomer = {
                    'customerId': UserControl.customer.id,
                    'encodedIban': encodedIban
                };
                $scope.ajaxCall('purchase', 'saveibantocustomer', 'POST', ibanCustomer,
                    function (response) {
                        if (!response.status) {
                            $scope.displayError(response.message);
                        }
                    });

                let postData = {
                    'dbName': 'customerdata',
                    'document': postBoxDocument,
                    'data': {
                        'shop': $scope.projectName,
                        'accountOwner': $scope.debit.accountOwner,
                        'bic': $scope.debit.bic,
                        'iban': $scope.debit.iban,
                    }
                };
                if ($scope.debit.overwrite) {
                    postboxHelper.patch('/carrier/' + postBoxDocument + '/document/', postData, function (response, request) {
                        $scope.resetDebitFormErrors();
                        $scope.loadPaymentData(true);
                    });
                } else {

                    postboxHelper.put('/carrier/document/', postData, function (response, request) {
                        $scope.resetDebitFormErrors();
                        $scope.loadPaymentData(true);
                    });
                }
            }
            $scope.checkCheckoutPossible();

        };

        $scope.registerForPaymentData = function () {
            let valid = $scope.checkPaymentForm();
            if (!valid) {
                $scope.showDebitFormErrors();
            } else {
                $scope.formStatus.userLoggedIn = false;
                $scope.formStatus.guestLoggedIn = false;
                $scope.formStatus.registerMode = true;
                $scope.formStatus.loginMode = false;
                $scope.formStatus.updateMode = false;
                $scope.formStatus.registerForPaymentMode = true;
                $scope.formStatus.loginForPaymentMode = false;
                $scope.debit.editable = false;
                $scope.resetDebitFormErrors();
                $scope.scrollTo('#register');
            }
        };

        $scope.goToLogin = function () {
            $scope.formStatus.userLoggedIn = false;
            $scope.formStatus.guestLoggedIn = false;
            $scope.formStatus.registerMode = false;
            $scope.formStatus.loginMode = true;
            $scope.formStatus.updateMode = false;
            $scope.formStatus.loginForPaymentMode = true;
            $scope.formStatus.registerForPaymentMode = false;
            $scope.scrollTo('#register');
        };
    };

    return service;
};

export default PaymentDataHelper;
